import {Component} from "@angular/core";
import {BannerApiService} from "../../api/banner-api.service";

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss']
})
export class HomeHeaderComponent {

  text: string;
  image: string;
  url: string;

  constructor(private bannerApi: BannerApiService) {
    bannerApi.getBanner().subscribe((banner) => {
      this.text = banner.bannerText;
      this.url = banner.bannerUrl;
      this.image = 'data:image/bmp;base64,' + banner.bannerImage;
    });
  }
}
